import React from "react";
import {
    Navigate,
    Route,
    BrowserRouter as Router,
    Routes,
} from "react-router-dom";
import RequireAuth from "./RequireAuth";
import RequireFeature from "./RequireFeature";
import RequireTemplateRelogin from "./RequireTemplateRelogin";
import AppShell from "./components/layout/AppShell";
import { AuthProvider } from "./contexts/AuthContext";
import { ConfigProvider } from "./contexts/ConfigContext";
import CreateTemplate from "./pages/CreateTemplate";
import Dashboard from "./pages/Dashboard";
import EditStaff from "./pages/EditStaff";
import ErrorPage from "./pages/ErrorPage";
import HomePage from "./pages/HomePage";
import Login from "./pages/Login";
import SelectBaseTemplate from "./pages/SelectBaseTemplate";
import SelectCheckList from "./pages/SelectCheckList";
import SelectTemplate from "./pages/SelectTemplate";
import SelectTodo from "./pages/SelectTodo";
import TemplateHome from "./pages/TemplateHome";
import TemplateSettings from "./pages/TemplateSettings";
import UseCheckList from "./pages/UseCheckList";
import AccountSettings from "./pages/AccountSettings";
import ChangePassword from "./pages/ChangePassword";
import UseTodo from "./pages/UseTodo";

// アプリ本体(env.jsなど)の最初
console.log("[App.js] Starting up...", new Date(), window.APP_CONFIG);

function App() {
  return (
    <AuthProvider>
      <ConfigProvider>
        <Router>
          <Routes>
            <Route path="/login" element={<Login />} />
            <Route path="/error" element={<ErrorPage />} />
            <Route element={<RequireAuth />}>
              <Route element={<AppShell />}>
                <Route path="/" exact element={<HomePage />} />
                <Route path="/dashboard" element={<Dashboard />} />
                <Route path="/todos/by-date/:scheduledOn" element={<UseTodo />} />
                <Route path="/todos/:year/:month" element={<SelectTodo />} />
                <Route path="/todos/:todoPublicId" element={<UseTodo />} />
                <Route path="/account" element={<AccountSettings />} />
                <Route path="/account/change-password" element={<ChangePassword />} />
                <Route element={<RequireTemplateRelogin />}>
                  <Route path="/templates/new" element={<CreateTemplate />} />
                  <Route
                    path="/templates/:templatePublicId/edit"
                    element={<CreateTemplate />}
                  />
                  <Route path="/templates" element={<TemplateHome />} />
                  <Route path="/templates/settings" element={<TemplateSettings />} />
                  <Route
                    path="/templates/select-base-template"
                    element={<SelectBaseTemplate />}
                  />
                  <Route
                    path="/templates/select-template"
                    element={<SelectTemplate />}
                  />
                </Route>
                <Route
                  element={
                    <RequireFeature featureKey="enableAssigneeSelection" />
                  }
                >
                  <Route path="/edit-staff/" element={<EditStaff />} />
                </Route>
                <Route element={<RequireFeature featureKey="enableCheckList" />}>
                  <Route path="/checklists" element={<SelectCheckList />} />
                  <Route
                    path="/checklists/:checklistId"
                    element={<UseCheckList />}
                  />
                </Route>
              </Route>
            </Route>
            <Route
              path="*"
              element={<Navigate to="/error?reason=not-found" replace />}
            />
          </Routes>
        </Router>
      </ConfigProvider>
    </AuthProvider>
  );
}

export default App;
